import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import globalvariable from "../globalvariables";
import Reports from "@/views/portal/Reports";
import RevenueReport from "@/views/revenue/RevenueReport";
import BlockUser from "@/views/BlockUser";
import UserHistory from "@/views/UserHistory.vue";
import CampaignHistory from "@/views/CampaignHistory.vue";
import BkashUserPaymentHistory from "@/views/BkashUserPaymentHistory.vue";
import Faqs from "@/views/faqs/Faqs.vue";
import FaqCreate from "@/views/faqs/FaqCreate.vue";
import FaqEdit from "@/views/faqs/FaqEdit.vue";


const permissionsList = globalvariable.permissionsList;
// Containers
const TheContainer = () => import(/* webpackChunkName: "[request]" *//* webpackChunkName: "[request]" */"@/containers/TheContainer");

// Views
const Dashboard = () => import(/* webpackChunkName: "[request]" */"@/views/Dashboard");

// const Colors = () => import(/* webpackChunkName: "[request]" */"@/views/theme/Colors");
// const Typography = () => import(/* webpackChunkName: "[request]" */"@/views/theme/Typography");

// const Charts = () => import(/* webpackChunkName: "[request]" */"@/views/charts/Charts");
// const Widgets = () => import(/* webpackChunkName: "[request]" */"@/views/widgets/Widgets");

// Views - Components
// const Cards = () => import(/* webpackChunkName: "[request]" */"@/views/base/Cards");
// const Forms = () => import(/* webpackChunkName: "[request]" */"@/views/base/Forms");
// const Switches = () => import(/* webpackChunkName: "[request]" */"@/views/base/Switches");
// const Tables = () => import(/* webpackChunkName: "[request]" */"@/views/base/Tables");
// const Tabs = () => import(/* webpackChunkName: "[request]" */"@/views/base/Tabs");
// const Breadcrumbs = () => import(/* webpackChunkName: "[request]" */"@/views/base/Breadcrumbs");
// const Carousels = () => import(/* webpackChunkName: "[request]" */"@/views/base/Carousels");
// const Collapses = () => import(/* webpackChunkName: "[request]" */"@/views/base/Collapses");
// const Jumbotrons = () => import(/* webpackChunkName: "[request]" */"@/views/base/Jumbotrons");
// const ListGroups = () => import(/* webpackChunkName: "[request]" */"@/views/base/ListGroups");
// const Navs = () => import(/* webpackChunkName: "[request]" */"@/views/base/Navs");
// const Navbars = () => import(/* webpackChunkName: "[request]" */"@/views/base/Navbars");
// const Paginations = () => import(/* webpackChunkName: "[request]" */"@/views/base/Paginations");
// const Popovers = () => import(/* webpackChunkName: "[request]" */"@/views/base/Popovers");
// const ProgressBars = () => import(/* webpackChunkName: "[request]" */"@/views/base/ProgressBars");
// const Tooltips = () => import(/* webpackChunkName: "[request]" */"@/views/base/Tooltips");

// Views - Buttons
// const StandardButtons = () => import(/* webpackChunkName: "[request]" */"@/views/buttons/StandardButtons");
// const ButtonGroups = () => import(/* webpackChunkName: "[request]" */"@/views/buttons/ButtonGroups");
// const Dropdowns = () => import(/* webpackChunkName: "[request]" */"@/views/buttons/Dropdowns");
// const BrandButtons = () => import(/* webpackChunkName: "[request]" */"@/views/buttons/BrandButtons");

// Views - Icons
// const CoreUIIcons = () => import(/* webpackChunkName: "[request]" */"@/views/icons/CoreUIIcons");
// const Brands = () => import(/* webpackChunkName: "[request]" */"@/views/icons/Brands");
// const Flags = () => import(/* webpackChunkName: "[request]" */"@/views/icons/Flags");

// Views - Notifications
// const Alerts = () => import(/* webpackChunkName: "[request]" */"@/views/notifications/Alerts");
// const Badges = () => import(/* webpackChunkName: "[request]" */"@/views/notifications/Badges");
// const Modals = () => import(/* webpackChunkName: "[request]" */"@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import(/* webpackChunkName: "[request]" */"@/views/pages/Page404");
const Page500 = () => import(/* webpackChunkName: "[request]" */"@/views/pages/Page500");
const Login = () => import(/* webpackChunkName: "[request]" */"@/views/Login");
const Register = () => import(/* webpackChunkName: "[request]" */"@/views/pages/Register");

// Users
// const User = () => import(/* webpackChunkName: "[request]" */"@/views/users/User");


// Custom Views

const Role = () => import(/* webpackChunkName: "[request]" */'../views/access_control/role/Role');
const RoleShow = () => import(/* webpackChunkName: "[request]" */'../views/access_control/role/RoleShow');
const CreateNewRole = () => import(/* webpackChunkName: "[request]" */'../views/access_control/role/CreateNewRole');
const RoleEdit = () => import(/* webpackChunkName: "[request]" */'../views/access_control/role/RoleEdit');

const Users = () => import(/* webpackChunkName: "[request]" */'../views/access_control/users/Users');
const UserShow = () => import(/* webpackChunkName: "[request]" */'../views/access_control/users/UserShow');
const CreateNewUser = () => import(/* webpackChunkName: "[request]" */'../views/access_control/users/CreateNewUser');
const UserEdit = () => import(/* webpackChunkName: "[request]" */'../views/access_control/users/UserEdit');

const Categories = () => import(/* webpackChunkName: "[request]" */"../views/categories/Categories");
const CategoryCreate = () => import(/* webpackChunkName: "[request]" */"../views/categories/CategoryCreate");
const CategoryEdit = () => import(/* webpackChunkName: "[request]" */"../views/categories/CategoryEdit");

const Topics = () => import(/* webpackChunkName: "[request]" */"../views/topics/Topics");
const TopicCreate = () => import(/* webpackChunkName: "[request]" */"../views/topics/TopicCreate");
const TopicEdit = () => import(/* webpackChunkName: "[request]" */"../views/topics/TopicEdit");

const Questions = () => import(/* webpackChunkName: "[request]" */"../views/questions/Questions");
const QuestionImport = () => import(/* webpackChunkName: "[request]" */"../views/questions/QuestionImport");
const QuestionCreate = () => import(/* webpackChunkName: "[request]" */"../views/questions/QuestionCreate");
const QuestionEdit = () => import(/* webpackChunkName: "[request]" */"../views/questions/QuestionEdit");

const Tournaments = () => import(/* webpackChunkName: "[request]" */"../views/tournaments/Tournaments");
// const ChallengeRoom = () => import(/* webpackChunkName: "[request]" */"../views/challenge_room/ChallengeRoom");
const TournamentCreate = () => import(/* webpackChunkName: "[request]" */"../views/tournaments/TournamentCreate");
const TournamentEdit = () => import(/* webpackChunkName: "[request]" */"../views/tournaments/TournamentEdit");
const TournamentRanking = () => import(/* webpackChunkName: "[request]" */"../views/tournaments/TournamentRanking");
const TournamentQuestions = () => import(/* webpackChunkName: "[request]" */"../views/tournaments/TournamentQuestions");

const DailyTasks = () => import(/* webpackChunkName: "[request]" */"../views/daily_tasks/DailyTasks");
const DailyTaskCreate = () => import(/* webpackChunkName: "[request]" */"../views/daily_tasks/DailyTaskCreate");
const DailyTaskEdit = () => import(/* webpackChunkName: "[request]" */"../views/daily_tasks/DailyTaskEdit");

const BkashPromotion = () => import(/* webpackChunkName: "[request]" */"../views/bkash_promotion/BkashPromotion")
const BkashPromotionCreate = () => import(/* webpackChunkName: "[request]" */"../views/bkash_promotion/BkashPromotionCreate")
const BkashPromotionEdit = () => import(/* webpackChunkName: "[request]" */"../views/bkash_promotion/BkashPromotionEdit")
const BkashPromotionBanner = () => import(/* webpackChunkName: "[request]" */"../views/bkash_promotion/BkashPromotionBanner")
const Promotions = () => import(/* webpackChunkName: "[request]" */"../views/promotions/Promotions");
const PromotionCreate = () => import(/* webpackChunkName: "[request]" */"../views/promotions/PromotionCreate");
const PromotionEdit = () => import(/* webpackChunkName: "[request]" */"../views/promotions/PromotionEdit");
const PopUp = () => import(/* webpackChunkName: "[request]" */"../views/promotions/PopUp");
const LeaderBoard = () => import(/* webpackChunkName: "[request]" */"../views/LeaderBoard");
const LeaderBoardManipulation = () => import(/* webpackChunkName: "[request]" */"../views/LeaderBoardManipulation");
const Recharges = () => import(/* webpackChunkName: "[request]" */"../views/Recharges");
const SubscriptionGratification = () => import(/* webpackChunkName: "[request]" */"../views/SubscriptionGratification");
const SendGratification = () => import(/* webpackChunkName: "[request]" */"../views/SendGratification");

const QuestionReports = () => import(/* webpackChunkName: "[request]" */"../views/question_reports/QuestionReports");
const QuestionReportEdit = () => import(/* webpackChunkName: "[request]" */"../views/question_reports/QuestionReportEdit");

const Favorite = () => import(/* webpackChunkName: "[request]" */"../views/Favorite");
const Store = () => import(/* webpackChunkName: "[request]" */"../views/Store");
const Ranking = () => import(/* webpackChunkName: "[request]" */"../views/Ranking");

Vue.use(Router);

const router = new Router({
    mode: "history", // https://router.vuejs.org/api/#mode
    linkActiveClass: "active",
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes(),
});

function configRoutes() {
    return [
        {
            path: "/",
            mode: "history",
            redirect: "/dashboard",
            name: "Home",
            meta: {
                requiresAuth: true,
            },
            component: TheContainer,
            children: [
                {
                    path: "dashboard",
                    name: "Dashboard",
                    component: Dashboard,
                },
                {
                    path: 'roles',
                    redirect: '/roles',
                    name: 'Roles',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Role,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: 'show/:id',
                            name: 'RoleShow',
                            component: RoleShow,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: 'new',
                            name: 'Create New Role',
                            component: CreateNewRole,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: 'edit/:id',
                            name: 'RoleEdit ',
                            component: RoleEdit,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        }
                    ]
                },
                {
                    path: 'users',
                    redirect: '/users',
                    name: 'Users',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Users,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: 'show/:id',
                            name: 'UserShow',
                            component: UserShow,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: 'new',
                            name: 'Create New User',
                            component: CreateNewUser,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: 'edit/:id',
                            name: 'Edit ',
                            component: UserEdit,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        }
                    ]
                },
                {
                    path: "categories",
                    name: "Categories",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "/",
                            name: "Categories",
                            component: Categories,
                        },
                        {
                            path: "/categories/create",
                            name: "CategoryCreate",
                            component: CategoryCreate,
                        },
                        {
                            path: "/categories/edit/:id",
                            name: "CategoryEdit",
                            component: CategoryEdit,
                        },
                    ],
                },
                {
                    path: "topics",
                    name: "Topics",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "/",
                            name: "Topics",
                            component: Topics,
                        },
                        {
                            path: "/topics/create",
                            name: "TopicCreate",
                            component: TopicCreate,
                        },
                        {
                            path: "/topics/edit/:id",
                            name: "TopicEdit",
                            component: TopicEdit,
                        },
                    ],
                },

                {
                    path: "faqs",
                    name: "Faqs",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "/",
                            name: "Faqs",
                            component: Faqs,
                        },
                        {
                            path: "/faqs/create",
                            name: "FaqCreate",
                            component: FaqCreate,
                        },
                        {
                            path: "/faqs/edit/:id",
                            name: "FaqEdit",
                            component: FaqEdit,
                        },
                    ],
                },

                {
                    path: "questions",
                    name: "Questions",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },



                children: [
                        {
                            path: "/",
                            name: "Questions",
                            component: Questions,
                        },
                        {
                            path: "/questions/import",
                            name: "QuestionImport",
                            component: QuestionImport,
                        },
                        {
                            path: "/questions/create",
                            name: "QuestionCreate",
                            component: QuestionCreate,
                        },
                        {
                            path: "/questions/edit/:id",
                            name: "QuestionEdit",
                            component: QuestionEdit,
                        },
                    ],
                },
                {
                    path: "reported-questions",
                    name: "QuestionReports",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "/",
                            name: "",
                            component: QuestionReports,
                        },
                        {
                            path: "/reported-questions/edit/:id",
                            name: "QuestionReportEdit",
                            component: QuestionReportEdit,
                        }
                    ],
                },
                {
                    path: "tournaments",
                    name: "Tournaments",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "/",
                            name: "Tournaments",
                            component: Tournaments,
                        },
                        {
                            path: "/tournaments/create",
                            name: "TournamentCreate",
                            component: TournamentCreate,
                        },
                        {
                            path: "/tournaments/edit/:id",
                            name: "TournamentEdit",
                            component: TournamentEdit,
                        },
                        {
                            path: "/tournaments/ranking/:id",
                            name: "TournamentRanking",
                            component: TournamentRanking,
                        },
                        {
                            path: "/tournaments/questions/:id",
                            name: "TournamentQuestions",
                            component: TournamentQuestions,
                        }
                    ],
                },
                // {
                //   name: "ChallengRoom" ,
                //     path: "challenge-room",
                //     component: {
                //         render(c) {
                //             return c("router-view");
                //         },
                //     },
                //     children:[
                //         {
                //             path: "/",
                //             name: "ChallengeRoom",
                //             component: ChallengeRoom,
                //         },
                //     ]
                // },
                {
                    name: "BkashPromotion" ,
                    path: "bkash-promotion",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children:[
                        {
                            path: "/",
                            name: "BkashPromotion",
                            component: BkashPromotion,
                        },
                        {
                            path: "/bkash-promotions/create",
                            name: "BkashPromotionCreate",
                            component: BkashPromotionCreate,
                        },
                        {
                            path: "/bkash-promotions/edit",
                            name: "BkashPromotionEdit",
                            component: BkashPromotionEdit,
                        },

                        {
                            path: "/bkash-promotions/banner",
                            name: "BkashPromotionBanner",
                            component: BkashPromotionBanner,
                        },
                    ]
                },

                {
                    path: "daily-tasks",
                    name: "DailyTasks",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "/",
                            name: "",
                            component: DailyTasks,
                        },
                        {
                            path: "/daily-tasks/create",
                            name: "DailyTaskCreate",
                            component: DailyTaskCreate,
                        },
                        {
                            path: "/daily-tasks/edit/:id",
                            name: "DailyTaskEdit",
                            component: DailyTaskEdit,
                        }
                    ],
                },
                {
                    path: "promotions",
                    name: "Promotions",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children:[
                        {
                            path: "/",
                            name: "",
                            component: Promotions,
                        },
                        {
                            path: "/promotions/create",
                            name: "PromotionCreate",
                            component: PromotionCreate,
                        },
                        {
                            path: "/promotions/edit/:id",
                            name: "PromotionEdit",
                            component: PromotionEdit
                        },
                        {
                            path: "/promotions/pop-up",
                            name: "PopUp",
                            component: PopUp
                        },
                    ]
                },
                {
                    path: "leaderboard",
                    name: "LeaderBoard",
                    component: LeaderBoard
                },
                {
                    path: "leaderboardManipulation",
                    name: "LeaderBoardManipulation",
                    component: LeaderBoardManipulation
                },
                {
                    path: "recharges",
                    name: "Recharges",
                    component: Recharges
                },
                {
                    path: "/gratification",
                    name: "SubscriptionGratification",
                    component:  {
                            render(c) {
                                return c("router-view");
                                },
                    },
                    children: [
                        {
                            path: "/",
                            name: "SubscriptionGratification",
                            component: SubscriptionGratification,
                        },
                        {
                            path: '/gratification/send/:id',
                            name:"SendGratification",
                            component: SendGratification,
                        },
                    ],
                },
                {
                    path: "favorites",
                    name: "favorites",
                    component: Favorite,
                },
                {
                    path: "store",
                    name: "store",
                    component: Store,
                },
                {
                    path: "ranking",
                    name: "ranking",
                    component: Ranking,
                },
                {
                    path: "reports",
                    name: "Reports",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children:[
                        {
                            path: "/",
                            name: "",
                            component: Reports,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: "/reports/revenue",
                            name: "Revenue table",
                            component: RevenueReport,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: "/bkash/user-payment-history",
                            name: "User Payment History",
                            component: BkashUserPaymentHistory,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: "/block/user",
                            name: "Block User",
                            component: BlockUser,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: "/user/history",
                            name: "UserHistory",
                            component: UserHistory,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                        {
                            path: "/campaign/history",
                            name: "CampaignHistory",
                            component: CampaignHistory,
                            meta: {
                                permission_name: 'manage roles'
                            },
                        },
                    ]
                },
            ],
        },
        { path: '*', component: Page404 },
        {
            path: "/",
            redirect: "/404",
            name: "Authentication",
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "404",
                    name: "Page404",
                    component: Page404,
                },
                {
                    path: "500",
                    name: "Page500",
                    component: Page500,
                },
                {
                    path: "login",
                    name: "Login",
                    component: Login,
                },
                {
                    path: "register",
                    name: "Register",
                    component: Register,
                },
            ],
        },
    ];
}

function checkRoutePermission(to) {
    const routeObj = to.matched[to.matched.length - 1];
    if (
        Object.prototype.hasOwnProperty.call(routeObj.meta, "permission_name")
    ) {
        return !!store.getters["auth/hasPermission"](
            routeObj.meta.permission_name
        );
    }
    return true;
}

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters["auth/isLoggedIn"]) {
            if (checkRoutePermission(to)) {
                next();
            }
            return;
        }
        next("login");
    } else if (store.getters["auth/isLoggedIn"]) {
        if (
            to.matched.some(
                (record) =>
                    record.name === "Login" || record.name === "Register"
            )
        ) {
            next("/dashboard");
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
